export class DhSecretKey {
  constructor( 
    public secretKeyBase64: string ){}
}
